package org.example.project.service

import androidx.compose.runtime.mutableStateMapOf
import org.example.project.utils.All

object ChatPopupService {

    private val popupsByNode = mutableStateMapOf<String, List<All>>()

    fun getPopups(node: String): List<All> = popupsByNode[node] ?: emptyList()

    fun openPopup(
        node: String,
        art: String,
        user: All? = null,
        conversationOnly: Boolean = false
    ) {
        if (node.isBlank() || art.isBlank()) return
        val popup = All(
            id = "chat-popup-${js("Date.now()") as Double}",
            key = "ChatPopup",
            art = art,
            bereich = node,
            userName = user?.id.orEmpty(),
            firmenId = user?.firmenId.orEmpty(),
            name = user?.name.orEmpty(),
            vorname = user?.vorname.orEmpty(),
            nachname = user?.nachname.orEmpty(),
            aktiv = conversationOnly
        )
        popupsByNode[node] = (popupsByNode[node] ?: emptyList()) + popup
    }

    fun closePopup(node: String, id: String) {
        popupsByNode[node] = (popupsByNode[node] ?: emptyList()).filterNot { it.id == id }
    }
}
